import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toolbar" }

import MonthYearPicker from "@/components/ui/input/MonthYearPicker.vue";
import {computed} from "vue";
import type {Region} from "@/types/files";
import RegionSelector from "@/components/ui/input/RegionSelector.vue";
import type {DistrictKey} from "@/composables/functions/getDistrictName";
import type {RegionKey} from "@/composables/functions/getRegionName";

interface Props {
  selectedRegions?: Region[];
  paramsSearchQuery?: string;
  activeMonth?: string;
  activeYear?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DatabaseToolbar',
  props: /*@__PURE__*/_mergeModels({
    selectedRegions: { default: () => [] },
    paramsSearchQuery: { default: "" },
    activeMonth: { default: "january" },
    activeYear: { default: () => new Date().getFullYear() }
  }, {
    "selectedDistrict": {required: true},
    "selectedDistrictModifiers": {},
    "selectedRegion": {required: true},
    "selectedRegionModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:selectedRegions", "update:paramsSearchQuery", "update:activeMonth", "update:activeYear"], ["update:selectedDistrict", "update:selectedRegion"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedDistrict = _useModel<DistrictKey | null>(__props, "selectedDistrict");
const selectedRegion = _useModel<RegionKey | null>(__props, "selectedRegion");

// Значение строки поиска параметров
const paramsSearchQueryValue = computed({
  get: () => props.paramsSearchQuery,
  set: (value) => emit("update:paramsSearchQuery", value)
});

return (_ctx: any,_cache: any) => {
  const _component_InputSearchPrimary = _resolveComponent("InputSearchPrimary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RegionSelector, {
      "selected-district": selectedDistrict.value,
      "onUpdate:selectedDistrict": _cache[0] || (_cache[0] = ($event: any) => ((selectedDistrict).value = $event)),
      "selected-region": selectedRegion.value,
      "onUpdate:selectedRegion": _cache[1] || (_cache[1] = ($event: any) => ((selectedRegion).value = $event))
    }, null, 8, ["selected-district", "selected-region"]),
    _createVNode(MonthYearPicker, {
      "model-month": props.activeMonth,
      "model-year": props.activeYear,
      "onUpdate:modelMonth": _cache[2] || (_cache[2] = (value) => emit('update:activeMonth', value)),
      "onUpdate:modelYear": _cache[3] || (_cache[3] = (value) => emit('update:activeYear', value))
    }, null, 8, ["model-month", "model-year"]),
    _createVNode(_component_InputSearchPrimary, {
      modelValue: paramsSearchQueryValue.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((paramsSearchQueryValue).value = $event)),
      placeholder: "Поиск по параметру"
    }, null, 8, ["modelValue"])
  ]))
}
}

})